// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"475":"9bc37e37","876":"ca4a51e5"}[chunkId] + ".chunk.js";
};